// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';

import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Locales from 'components/Locales';
import StepUpDialog from 'components/StepUpDialog';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { AuthProvider } from 'contexts/AuthContext';

// ==============================|| APP - THEME, LOCALE, AUTH, ROUTER ||============================== //
//
// Order matters. The locale is needed by everything below it. The auth provider renders nothing
// until the session is known, so the router and the global dialogs sit inside it.

const App = () => (
  <ThemeCustomization>
    <RTLLayout>
      <ScrollTop>
        <Locales>
          <AuthProvider>
            <Notistack>
              <Routes />
              <StepUpDialog />
              <Snackbar />
            </Notistack>
          </AuthProvider>
        </Locales>
      </ScrollTop>
    </RTLLayout>
  </ThemeCustomization>
);

export default App;
